import React from "react";
import { ReactComponent as Logo } from "../../../img/glo-logo.svg";
import "../VideoPage/style.scss";
import bg from "../../../img/bg-mobilev3.png";
export default function LoadingPage() {
  return (
    <section className="video-page">
      <div className="container">
        <div className="content-container">
          <Logo className="logo" />
          <img className="glo-devices" src={bg} alt="glo hyper" />
          <div className="content">
            <h2>gLO™ HYPER AIR</h2>
            <div className="description">
              <p>
                Obejrzyj film <span>i poznaj nasze urządzenia</span>
              </p>
            </div>
          </div>
        </div>
        <div className="placeholder">
          <h3>Trwa ładowanie...</h3>
        </div>
        <p className="disclaimer">Niepubliczna informacja konsumencka</p>
      </div>
    </section>
  );
}
